import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { RadioGroup } from '@progress/kendo-react-inputs';
import { FormFieldWrapper } from '../FormFieldWrapper';
import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';

interface FormBoolRadioGroupProps extends FieldRenderProps {
  isLoading?: boolean;
}

export const FormBoolRadioGroup: React.FC<FormBoolRadioGroupProps> = fieldRenderProps => {
  const { disabled, isLoading } = fieldRenderProps;
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const data = [
    {
      label: translate('custom.common.yes'),
      value: true
    },
    {
      label: translate('custom.common.no'),
      value: false
    }
  ];
  return (
    <FormFieldWrapper
      validationMessage={fieldRenderProps.validationMessage}
      value={fieldRenderProps.value}
      touched={fieldRenderProps.touched}
      id={fieldRenderProps.id}
      valid={fieldRenderProps.valid}
      disabled={fieldRenderProps.disabled}
      hint={fieldRenderProps.hint}
      label={fieldRenderProps.label}
      wrapperStyle={fieldRenderProps.wrapperStyle}
      optional={fieldRenderProps.optional}
      modified={fieldRenderProps.modified}
      visited={fieldRenderProps.visited}
      onChange={fieldRenderProps.onChange}
      onFocus={fieldRenderProps.onFocus}
      onBlur={fieldRenderProps.onBlur}
      name={fieldRenderProps.name}
      isLoading={isLoading}
    >
      <RadioGroup
        data={data}
        value={fieldRenderProps.value}
        onChange={fieldRenderProps.onChange}
        valid={fieldRenderProps.valid}
        disabled={disabled}
      />
    </FormFieldWrapper>
  );
};
